import { Button, Spin } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Swal from "sweetalert2";

import { api, endpoint } from "@/api";

export const CreateSystemParameter = ({ getParameters }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [parameterData, setParameterData] = useState({
    name: "",
    type: "",
    value: "",
  });
  const { name, type, value } = parameterData;

  const onInputChange = (e) => {
    setParameterData({ ...parameterData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const { message } = await api.post(endpoint.create_system_parameter, parameterData);
      Swal.fire({
        title: "Done!",
        text: message,
        icon: "success",
        timer: 2000,
        confirmButtonText: "OK",
      });
      setParameterData({ name: "", type: "", value: "" });
      getParameters();
    } catch {
      Swal.fire({
        title: "",
        text: "Something went wrong",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
    e.target.reset();
    setIsLoading(false);
    return;
  };
  return (
    <div className="col-md-4">
      <h5 className="mb-3">Add New System Parameter</h5>
      <Spin spinning={isLoading}>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              System Parameter Name
            </label>
            <input
              type="text"
              name="name"
              value={name}
              onChange={onInputChange}
              className="form-control"
              id="name"
              placeholder="Enter system parameter name"
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="type" className="form-label">
              System Parameter Type
            </label>
            <select name="type" id="type" className="form-select" value={type} onChange={onInputChange}>
              <option>Select system parameter type</option>
              <option value="Measured Value">Measured Value</option>
              <option>Default Value</option>
            </select>
          </div>
          <div className="mb-3">
            <label htmlFor="value" className="form-label">
              Unit / Value
            </label>
            <input
              type="text"
              name="value"
              value={value}
              onChange={onInputChange}
              className="form-control"
              id="value"
              placeholder="Enter Parameter Value"
              required
            />
          </div>
          <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
            <Button type="primary" htmlType="submit">
              Create New Parameter
            </Button>
          </div>
        </form>
      </Spin>
    </div>
  );
};

CreateSystemParameter.propTypes = {
  getParameters: PropTypes.func.isRequired,
};
